import firstLetterUppercase from "src/shared/util/first-letter-uppercase";
import { SpanProductName } from "../style/ProductName.style";

export type ProductNameVariant = "normal" | "highlight" | "modal";
interface Props {
  name: string;
  variant?: ProductNameVariant;
}

const ProductName = ({ name, variant = "normal" }: Props) => {
  return (
    <SpanProductName className="akn-product-name" $variant={variant}>
      {firstLetterUppercase(name)}
    </SpanProductName>
  );
};

export default ProductName;
